/**
 * A store used for global states related to UI management.
 */
import {create} from 'zustand';

interface BreadcrumbItem {
  link: string;
  label: string;
}
interface UIState {
  title: string
  breadcrumbItems?: BreadcrumbItem[] | null
  setTitle: {(title: string): void}
  setBreadcrumbs: {(breadcrumbItems: BreadcrumbItem[]): void}
  clearBreadcrumbs: {(): void}
}

export const useUIStore = create<UIState>((set) => ({
  title: '',
  breadcrumbItems: null,
  setTitle: (title) => set({ title }),
  setBreadcrumbs: (breadcrumbItems) => set({ breadcrumbItems }),
  clearBreadcrumbs: () => set(() => ({ breadcrumbItems: null })),
}));
